import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataService } from './data.service';

export enum FieldKeyItemSource {
  Inspection = 1,
  Application = 2,
  InspectionCustomFields = 3
}

export interface FieldKeyItem {
  fieldKey: string;
  label: string;
  source: FieldKeyItemSource;
}

export interface HomePageColumnMapping {
  priority: number;
  fieldKey: string;
  source: FieldKeyItemSource;
}

export interface HomePageColumnConfiguration {
  label: string;
  mappings: HomePageColumnMapping[];
}

export interface GetInspectionAppConfigurationRequest {
  clientId: string;
  departmentId?: string;
}

export interface SaveInspectionAppConfigurationRequest {
  clientId: string;
  departmentId?: string;
  homePageColumns: { [key: number]: HomePageColumnConfiguration };
  applicationDetails: { [key: number]: HomePageColumnConfiguration };
}

export interface GetAvailableHomePageColumnFieldsResponse {
  availableFields: FieldKeyItem[];
}

export interface SaveInspectionAppConfigurationResponse {
  inspectionDataConfigurationId: string;
  homePageColumns: { [key: number]: HomePageColumnConfiguration };
  applicationDetails: { [key: number]: HomePageColumnConfiguration };
}

@Injectable({
  providedIn: 'root'
})
export class InspectionAppConfigurationService {
  constructor(private _dataSvc: DataService) {}

  getAvailableFields(
    clientId: string,
    departmentId?: string
  ): Observable<GetAvailableHomePageColumnFieldsResponse> {
    return this._dataSvc.getAvailableInspectionAppHomePageColumnFields(clientId, departmentId);
  }

  getConfiguration(
    clientId: string,
    departmentId?: string
  ): Observable<SaveInspectionAppConfigurationResponse> {
    return this._dataSvc.getInspectionAppConfiguration(clientId, departmentId);
  }

  saveConfiguration(
    clientId: string,
    departmentId: string | undefined,
    homePageColumns: { [key: number]: HomePageColumnConfiguration },
    applicationDetails: { [key: number]: HomePageColumnConfiguration }
  ): Observable<SaveInspectionAppConfigurationResponse> {
    const request: SaveInspectionAppConfigurationRequest = {
      clientId,
      departmentId,
      homePageColumns,
      applicationDetails
    };
    return this._dataSvc.saveInspectionAppConfiguration(request);
  }

  deleteConfiguration(
    clientId: string,
    departmentId?: string
  ): Observable<boolean> {
    return this._dataSvc.deleteInspectionAppConfiguration(clientId, departmentId);
  }
}
